import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=43609cc6&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43609cc6')) {
      api.createRecord('43609cc6', component.options)
    } else {
      api.reload('43609cc6', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=43609cc6&", function () {
      api.rerender('43609cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uNU0VI6AmA82/JS/pricehelp.vue"
export default component.exports